import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private Settings Types */
import { _Settings } from '../namespace-helper'

export default {
  namespaced: true,
  state: {
    // <--- accountStuff --->
    user: {},
    frontendPermissionsUser: null,
    translation: [{
      translatedText: '',
      detectedSourceLanguage: ''
    }],
    account: {},
    loading: false,
    // <--- supplierSettings --->
    openNewSupplierDialog: false,
    supplierBranchOffices: null,
    selectedSupplier: {
      id: 0,
      name: '',
      email: '',
      website: ''
    },
    selectedBranchOffice: {
      name: '',
      taxnumber: '',
      street: '',
      hnumber: '',
      city: '',
      zipcode: '',
      contry: '',
      suppliers_id: null
    },
    suppliers: [],
    manufacturerSuppliers: [],
    // <--- bank accounts --->
    branchOfficeBankAccounts: null,
    selectedBranchBankAccount: {
      id: 0,
      name: '',
      iban: '',
      bic: '',
      suppliers_branch_offices_id: null
    },
    // <--- terms --->
    termsOfDeliveries: null,
    termsOfPayments: null,
    // <--- units --->
    units: [],
    // <--- currencies --->
    currencies: [],
    // <--- delivery time types --->
    deliveryTimeTypes: [],

    // <--- exchange rate --->
    exchangeRate: {
      rates: {

      }
    },
    // <--- network stuff --->
    networkError: null,
    allSuppliers: []
  },
  mutations: {
    /* Account stuff */
    [_Settings.mutations.setAccount] (state, payload) {
      state.account = payload
    },
    [_Settings.mutations.setUser] (state, payload) {
      state.user = payload
    },
    [_Settings.mutations.setUserFrontendPermissions] (state, payload) {
      state.frontendPermissionsUser = payload
    },
    /* Translation stuff */
    [_Settings.mutations.setTranslation] (state, payload) {
      state.translation = payload
    },
    /* Supplier stuff */
    [_Settings.mutations.setSuppliers] (state, payload) {
      state.suppliers = payload
    },
    [_Settings.mutations.setAllSuppliers] (state, payload) {
      state.allSuppliers = payload
    },
    [_Settings.mutations.setManufacturerSuppliers] (state, payload) {
      state.manufacturerSuppliers = payload
    },
    [_Settings.mutations.setOpenCloseNewSupplierDialog] (state) {
      state.openNewSupplierDialog = !state.openNewSupplierDialog
    },
    [_Settings.mutations.setSelectedSupplier] (state, payload) {
      if (payload !== null) {
        state.selectedSupplier = payload
      } else {
        state.selectedSupplier = {
          id: 0,
          name: '',
          email: '',
          website: ''
        }
      }
    },
    [_Settings.mutations.setSelectedBranchOffice] (state, payload) {
      if (payload !== null) {
        state.selectedBranchOffice = payload
      } else {
        state.selectedBranchOffice = {
          name: '',
          taxnumber: null,
          street: null,
          hnumber: null,
          city: null,
          zipcode: null,
          contry: null,
          suppliers_id: null,
          terms_of_deliveries_id: null,
          terms_of_payments_id: null
        }
      }
    },
    [_Settings.mutations.addNewBranchOffice] (state, payload) {
      if (state.supplierBranchOffices === null) {
        state.supplierBranchOffices = []
      }
      state.supplierBranchOffices.push(payload)
    },
    [_Settings.mutations.removeBranchOffice] (state, payload) {
      state.supplierBranchOffices.splice(payload, 1)
    },
    [_Settings.mutations.setBranchOffices] (state, payload) {
      state.supplierBranchOffices = payload
    },
    /* bank accounts */
    [_Settings.mutations.addNewBranchOfficeBankAccount] (state, payload) {
      if (state.branchOfficeBankAccounts === null) {
        state.branchOfficeBankAccounts = []
      }
      state.branchOfficeBankAccounts.push(payload)
    },
    [_Settings.mutations.setSelectedBranchOfficeBankAccount] (state, payload) {
      if (payload !== null) {
        state.selectedBranchBankAccount = payload
      } else {
        state.selectedBranchBankAccount = {
          id: null,
          name: '',
          iban: '',
          bic: '',
          suppliers_branch_offices_id: null
        }
      }
    },
    [_Settings.mutations.removeBranchOfficeBankAccount] (state, payload) {
      state.branchOfficeBankAccounts.splice(payload, 1)
    },
    [_Settings.mutations.setBranchOfficesBankAccounts] (state, payload) {
      state.branchOfficeBankAccounts = payload
    },
    /* terms */
    [_Settings.mutations.setTermsOfDeliveries] (state, payload) {
      state.termsOfDeliveries = payload
    },
    [_Settings.mutations.setTermsOfPayments] (state, payload) {
      state.termsOfPayments = payload
    },
    /* Network stuff */
    [_Settings.mutations.setLoading] (state, payload) {
      state.loading = payload
    },
    [_Settings.mutations.setUnits] (state, payload) {
      state.units = payload
    },
    [_Settings.mutations.setCurrencies] (state, payload) {
      state.currencies = payload
    },
    [_Settings.mutations.setDeliveryTimeTypes] (state, payload) {
      state.deliveryTimeTypes = payload
    },
    [_Settings.mutations.setExchangeRate] (state, payload) {
      state.exchangeRate = payload
    },
    [_Settings.mutations.setNetworkError] (state, payload) {
      state.networkError = payload
    }
  },
  actions: {
    [_Settings.actions.saveSettings] ({ commit }, payload) {
      commit(_Settings.mutations.setLoading, true)
    },
    /* Account stuff */
    [_Settings.actions.loadAccount] (context, payload) {
      var url = API_URL + '/api/v1/users/ownuser/details'

      context.commit(_Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        context.commit(_Settings.mutations.setLoading, false)
        context.commit(_Settings.mutations.setAccount, r.data.data[0].accounts[0])
        context.commit(_Settings.mutations.setUser, r.data.data[0])
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_Settings.actions.loadFrontendPermissions] (context, payload) {
      var url = API_URL + '/api/v1/users/ownuser/details'

      context.commit(_Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        context.commit(_Settings.mutations.setLoading, false)
        context.commit(_Settings.mutations.setUserFrontendPermissions, r.data.data[0])
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_Settings.actions.saveAccount] (context, payload) {
      var url = API_URL + '/api/v1/accounts/' + payload.id

      context.commit(_Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)

      return axios.put(url, data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        context.commit(_Settings.mutations.setLoading, false)
        SuccessHandler.handleApiSuccess(store, r.data.message)
        ErrorHandler.clear(store)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    /* Supplier stuff */
    [_Settings.actions.openCloseNewSupplierDialog] ({ commit }, payload) {
      commit('setOpenCloseNewSupplierDialog')
    },
    [_Settings.actions.createSupplier] (context, payload) {
      context.commit(_Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)

      if (payload.id === 0) {
        var url = API_URL + '/api/v1/suppliers'

        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_Settings.mutations.setSelectedSupplier, r.data.data)
          SuccessHandler.handleApiSuccess(store, r.data.message)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      } else {
        url = API_URL + '/api/v1/suppliers/' + payload.id
        axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_Settings.mutations.setSelectedSupplier, r.data.data)
          SuccessHandler.handleApiSuccess(store, r.data.message)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      }
    },
    [_Settings.actions.removeSupplier] (context, payload) {
      context.commit(_Settings.mutations.setLoading, true)

      var url = API_URL + '/api/v1/suppliers/' + payload.id

      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_Settings.mutations.setSelectedSupplier, r.data.data)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_Settings.mutations.setLoading, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Settings.actions.loadAllAccounts] (context, payload) {
      context.commit(_Settings.mutations.setLoading, true)

      var url = API_URL + '/api/v1/accounts'

      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          context.commit(_Settings.mutations.setLoading, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Settings.actions.loadSuppliers] (context, payload) {
      console.log('loadSuppliers: ' + JSON.stringify(payload))
      console.log('loadSuppliers: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/suppliers?limit=' + payload.limit + '&page=' + payload.page + '&search=' + payload.search + '&searchFields=id:like;name:like;email:like;website:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending + ''

      context.commit(_Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        context.commit(_Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_Settings.mutations.setSuppliers, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_Settings.actions.loadAllSuppliers] (context, payload) {
      console.log('loadAllSuppliers: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/suppliers'

      context.commit(_Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        context.commit(_Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_Settings.mutations.setAllSuppliers, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_Settings.actions.loadSuppliersByManufacturers] (context, payload) {
      console.log('loadSuppliersByManufacturers: ' + JSON.stringify(payload))

      context.commit(_Settings.mutations.setSuppliers, [])

      var url = API_URL + '/api/v1/suppliers/manufacturer/' + payload

      context.commit(_Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        context.commit(_Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_Settings.mutations.setManufacturerSuppliers, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_Settings.actions.setSelectedSupplier] ({ commit }, payload) {
      commit(_Settings.mutations.setSelectedSupplier, payload)
    },
    [_Settings.actions.setSelectedBranchOffice] ({ commit }, payload) {
      commit(_Settings.mutations.setSelectedBranchOffice, payload)
    },
    [_Settings.actions.setBranchOffices] ({ commit }, payload) {
      commit(_Settings.mutations.setBranchOffices, payload)
    },
    [_Settings.actions.addNewBranchOffice] ({ commit }, payload) {
      commit(_Settings.mutations.addNewBranchOffice, payload)
    },
    [_Settings.actions.removeBranchOffice] (context, payload) {
      var tempBranchOffices = context.getters.getSupplierBranchOffices
      var id = tempBranchOffices[payload].id

      if (id === null) {
        context.commit(_Settings.mutations.removeBranchOffice, payload)
        return
      }

      var url = API_URL + '/api/v1/supplierBranchOffices/' + id

      console.log('removeBranchOffice: ' + id)

      context.commit(_Settings.mutations.setLoading, true)

      axios.delete(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_Settings.mutations.removeBranchOffice, payload)
        SuccessHandler.handleApiSuccess(store, r.data.message)
        context.commit(_Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        context.commit(_Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_Settings.actions.saveBranchOffices] (context, payload) {
      context.commit(_Settings.mutations.setLoading, true)

      payload.forEach(function (v, i, o) {
        const data = JSON.stringify(v)

        if (v.id === null) {
          var url = API_URL + '/api/v1/supplierBranchOffices'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            context.commit(_Settings.mutations.setLoading, false)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/supplierBranchOffices/' + v.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            context.commit(_Settings.mutations.setLoading, false)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_Settings.actions.loadSupplierBranchOffices] (context, payload) {
      var url = API_URL + '/api/v1/supplierBranchOffices/supplier/' + payload

      console.log('loadSupplierBranchOffices: ' + payload)

      context.commit(_Settings.mutations.setLoading, true)

      axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_Settings.mutations.setBranchOffices, r.data.data)
        console.log('loadSupplierBranchOffices: ' + JSON.stringify(r.data))
        context.commit(_Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        context.commit(_Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    /* bank accounts */
    [_Settings.actions.removeBranchOfficeBankAccount] (context, payload) {
      var tempBranchOfficeBankBankAccount = context.getters.getBranchOfficeBankAccounts
      var id = tempBranchOfficeBankBankAccount[payload].id

      if (id === 0) {
        context.commit(_Settings.mutations.removeBranchOfficeBankAccount, payload)
        return
      }

      var url = API_URL + '/api/v1/supplierBankAccounts/' + id

      console.log('removeBranchOfficeBankAccount: ' + id)

      context.commit(_Settings.mutations.setLoading, true)

      axios.delete(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_Settings.mutations.removeBranchOfficeBankAccount, payload)
        SuccessHandler.handleApiSuccess(store, r.data.message)
        context.commit(_Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        context.commit(_Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    /* terms */
    [_Settings.actions.loadTermsOfDeliveries] (context, payload) {
      var url = API_URL + '/api/v1/termOfDeliveries'

      console.log('loadTermsOfDeliveries:')

      context.commit(_Settings.mutations.setLoading, true)

      axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_Settings.mutations.setTermsOfDeliveries, r.data.data)
        console.log('loadTermsOfDeliveries: ' + JSON.stringify(r.data))
        context.commit(_Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        context.commit(_Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_Settings.actions.loadTermsOfPayments] (context, payload) {
      var url = API_URL + '/api/v1/termOfPayments'

      console.log('loadTermsOfPayments:')

      context.commit(_Settings.mutations.setLoading, true)

      axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_Settings.mutations.setTermsOfPayments, r.data.data)
        console.log('loadTermsOfPayments: ' + JSON.stringify(r.data))
        context.commit(_Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        context.commit(_Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    /* contact person */
    [_Settings.actions.addNewBranchOfficeContact] ({ commit }, payload) {
      commit(_Settings.mutations.addNewBranchOfficeContact, payload)
    },
    [_Settings.actions.setSelectedBranchOfficeContact] ({ commit }, payload) {
      commit(_Settings.mutations.setSelectedBranchOfficeContact, payload)
    },
    [_Settings.actions.removeBranchOfficeContact] (context, payload) {
      var tempBranchOfficesContacts = context.getters.getBranchOfficeContacts
      var id = tempBranchOfficesContacts[payload].id

      if (id === null) {
        context.commit(_Settings.mutations.removeBranchOfficeContact, payload)
        return
      }

      var url = API_URL + '/api/v1/supplierContacts/' + id

      console.log('removeBranchOfficeContact: ' + id)

      context.commit(_Settings.mutations.setLoading, true)

      axios.delete(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_Settings.mutations.removeBranchOfficeContact, payload)
        SuccessHandler.handleApiSuccess(store, r.data.message)
        context.commit(_Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        context.commit(_Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    /* Bank Accounts */
    [_Settings.actions.saveBranchOfficeBankAccounts] (context, payload) {
      context.commit(_Settings.mutations.setLoading, true)

      payload.forEach(function (v, i, o) {
        const data = JSON.stringify(v)

        if (v.id === 0) {
          var url = API_URL + '/api/v1/supplierBankAccounts'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            context.commit(_Settings.mutations.setLoading, false)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/supplierBankAccounts/' + v.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            context.commit(_Settings.mutations.setLoading, false)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_Settings.actions.loadBranchOfficeBankAccounts] (context, payload) {
      var url = API_URL + '/api/v1/supplierBankAccounts/branchOffice/' + payload

      console.log('loadBranchOfficeBankAccounts: ' + payload)

      context.commit(_Settings.mutations.setLoading, true)

      axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_Settings.mutations.setBranchOfficesBankAccounts, r.data.data)
        console.log('loadBranchOfficeBankAccounts: ' + JSON.stringify(r.data))
        context.commit(_Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        context.commit(_Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_Settings.actions.translate] (context, payload) {
      var url = API_URL + '/api/v1/translations?q=' + encodeURIComponent(payload.q) + '&target=' + payload.target

      console.log('translate: ' + JSON.stringify(payload))

      context.commit(_Settings.mutations.setLoading, true)

      axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_Settings.mutations.setTranslation, r.data.data)
        console.log('translate: ' + JSON.stringify(r.data))
        context.commit(_Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        context.commit(_Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_Settings.actions.loadExchangeRate] (context, payload) {
      var url = API_URL + '/api/v1/currencyExchanges?base=' + payload

      console.log('loadExchangeRate: ' + JSON.stringify(payload))

      context.commit(_Settings.mutations.setLoading, true)

      axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_Settings.mutations.setExchangeRate, r.data.data)
        console.log('exchangeRates: ' + JSON.stringify(r.data))
        context.commit(_Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        context.commit(_Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    /* bank account */
    [_Settings.actions.addNewBranchOfficeBankAccount] ({ commit }, payload) {
      commit(_Settings.mutations.addNewBranchOfficeBankAccount, payload)
    },
    [_Settings.actions.setSelectedBranchOfficeBankAccount] ({ commit }, payload) {
      commit(_Settings.mutations.setSelectedBranchOfficeBankAccount, payload)
    },
    [_Settings.actions.loadAllUnits] (context, payload) {
      console.log('loadAllUnits: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/units'

      context.commit(_Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        context.commit(_Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_Settings.mutations.setUnits, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_Settings.actions.loadAllCurrencies] (context, payload) {
      console.log('loadAllCurrencies: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/currencies'

      context.commit(_Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        context.commit(_Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_Settings.mutations.setCurrencies, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_Settings.actions.loadAllDeliveryTimeTypes] (context, payload) {
      console.log('loadAllDeliveryTimeTypes: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/deliveryTimeTypes'

      context.commit(_Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        context.commit(_Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_Settings.mutations.setDeliveryTimeTypes, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    /* Network stuff */
    [_Settings.actions.clearNetworkError] (context, payload) {
      ErrorHandler.clear(store)
    },
    [_Settings.actions.resetState] ({ commit }, payload) {
      /*    commit(_Settings.mutations.setAccount, []) */
      commit(_Settings.mutations.setSuppliers, [])
      commit(_Settings.mutations.setAllSuppliers, [])
      commit(_Settings.mutations.setManufacturerSuppliers, [])
      commit(_Settings.mutations.setSelectedSupplier, null)
      commit(_Settings.mutations.setSelectedBranchOffice, [])
      commit(_Settings.mutations.setBranchOffices, [])
      // commit(_Settings.mutations.setSelectedBranchOfficeContact, null)
      commit(_Settings.mutations.setTermsOfDeliveries, [])
      commit(_Settings.mutations.setTermsOfPayments, [])
      commit(_Settings.mutations.setSelectedBranchOfficeBankAccount, null)
      commit(_Settings.mutations.setBranchOfficesBankAccounts, [])
      commit(_Settings.mutations.setUnits, [])
      /*      commit(_Settings.mutations.setUser, [])
      commit(_Settings.mutations.setUserFrontendPermissions, []) */
      commit(_Settings.mutations.setTranslation, [{
        translatedText: '',
        detectedSourceLanguage: ''
      }])
      // commit(_Settings.mutations.setCurrencies, [])
      commit(_Settings.mutations.setDeliveryTimeTypes, [])
      // commit(_Settings.mutations.setExchangeRate, [])
    }
  },
  getters: {
    /* Account stuff */
    [_Settings.getters.getAccount] (state) {
      return state.account
    },
    /* Supplier stuff */
    [_Settings.getters.getSuppliers] (state) {
      return state.suppliers
    },
    [_Settings.getters.getAllSuppliers] (state) {
      return state.allSuppliers
    },
    [_Settings.getters.getManufacturerSuppliers] (state) {
      return state.manufacturerSuppliers
    },
    [_Settings.getters.getSelectedSupplier] (state) {
      return state.selectedSupplier
    },
    [_Settings.getters.getSelectedBranchOffice] (state) {
      return state.selectedBranchOffice
    },
    [_Settings.getters.getSupplierBranchOffices] (state) {
      return state.supplierBranchOffices
    },
    [_Settings.getters.getOpenNewSupplierDialogState] (state) {
      return state.openNewSupplierDialog
    },
    /* contact persons */
    [_Settings.getters.getSelectedBranchOfficeContact] (state) {
      return state.selectedBranchOfficeContact
    },
    /* bank accounts */
    [_Settings.getters.getBranchOfficeBankAccounts] (state) {
      return state.branchOfficeBankAccounts
    },
    [_Settings.getters.getSelectedBranchOfficeBankAccount] (state) {
      return state.selectedBranchBankAccount
    },
    /* terms */
    [_Settings.getters.getTermsOfDeliveries] (state) {
      return state.termsOfDeliveries
    },
    [_Settings.getters.getTermsOfPayments] (state) {
      return state.termsOfPayments
    },
    /* Network stuff */
    [_Settings.getters.getNetworkError] (state) {
      return state.networkError
    },
    [_Settings.getters.getAllUnits] (state) {
      return state.units
    },
    [_Settings.getters.getAllCurrencies] (state) {
      return state.currencies
    },
    [_Settings.getters.getAllDeliveryTimeTypes] (state) {
      return state.deliveryTimeTypes
    },
    [_Settings.getters.loading] (state) {
      return state.loading
    },
    [_Settings.getters.getUser] (state) {
      return state.user
    },
    [_Settings.getters.getUserFrontendPermissions] (state) {
      return state.frontendPermissionsUser
    },
    /* Translation stuff */
    [_Settings.getters.getTranslation] (state) {
      return state.translation
    },
    /* Exchange rate stuff */
    [_Settings.getters.getExchangeRate] (state) {
      return state.exchangeRate
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Settings/settings.js